import React from 'react';

const WhatsappButton = ({
    phoneNumber = '917547869426', // Removed '+'
    message = 'Thank you for contacting LearnQuranEasily. Please leave your inquiry here, and our team will get back to you shortly.'
}) => {
    // const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
        <a href={`https://wa.me/${phoneNumber}?text=${message}`} className="btn-whatsapp-pulse" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-whatsapp"></i>
        </a>
    );
};

export default WhatsappButton;
